<template>
  <input
    type="text"
    class="input-text"
    v-model="searchText"
    @input="searchMap"
    >
</template>

<script>
import _ from 'lodash'
import axios from 'axios'
const key = process.env.VUE_APP_GOOGLE_MAP_KEY
const endpoint = 'https://maps.googleapis.com/maps/api/geocode/json'

export default {
  data () {
    return {
      searchText: ''
    }
  },

  methods: {
    searchMap: _.throttle(async function () {
      if (this.searchText === '') {
        return
      }

      const result = await axios.get(endpoint, {
        params: {
          key: key,
          address: this.searchText
        }
      })
      this.$emit('searchResult', result.data.results[0])
    }, 2000)
  }
}
</script>
